import axios from 'axios';
import Observer from 'common/scripts/observer';
import RangeSlider from 'components/range-slider';
import {Utils} from 'common/scripts/utils';

const observer = new Observer();

class SearchPanel {
    constructor(elem) {
        this.elem = elem;

        this.loadingClass = 'is-loading';
    }

    init() {
        if (!this.elem) {
            return;
        }

        this._initElements();
        this._initSliders();
        this._bindEvents();
    }

    _initElements() {
        this.submit = this.elem.querySelector('.j-search-panel__button');
        this.submitText = this.elem.querySelector('.j-search-panel__button-text');
        this.sliderPriceElem = this.elem.querySelector('.j-search-panel__price');
    }

    _initSliders() {
        if (!this.sliderPriceElem) {
            return;
        }

        this.sliderPrice = new RangeSlider();

        this.sliderPrice.init({
            name   : 'miniFilterPrice',
            wrapper: this.sliderPriceElem
        });
    }

    _bindEvents() {
        this.elem.addEventListener('change', () => {
            this._send();
        });

        this._changeSliders = this._changeSliders.bind(this);
        observer.subscribe('rangeSliderFinish', this._changeSliders);
    }

    _changeSliders(slider, name) {
        if (name === this.sliderPrice.name) {
            this._send();
        }
    }

    _send() {
        const formData = new FormData(this.elem);
        const action = this.elem.dataset.action;
        const method = (this.elem.dataset.method || 'get').toLowerCase();

        this._onLoad();

        axios[method](action, formData)
            .then((response) => {
                const {data} = response.data;

                if (data.count) {
                    this._replaceCount(data.count);
                }
            })
            .catch((error) => {
                console.error(error); // eslint-disable-line
            })
            .then(() => {
                const href = `${this.submit.getAttribute('href')}?${new URLSearchParams(formData).toString()}`;

                this._offLoad();
                this.submit.setAttribute('href', href);
            });
    }

    _onLoad() {
        this.submit.classList.add(this.loadingClass);
    }

    _offLoad() {
        this.submit.classList.remove(this.loadingClass);
    }

    _replaceCount(count) {
        Utils.clearHtml(this.submitText);
        Utils.insetContent(this.submitText, count);
    }
}

const searchPanel = document.querySelector('.j-search-panel');

if (searchPanel) {
    new SearchPanel(searchPanel).init();
}
